import React, { useState } from "react";
import { formatCurrency } from "../../../utils/format";

const BudgetSummary = ({ budgets = [] }) => {
  const [expandedCardId, setExpandedCardId] = useState(null);

  const getProgressColorClass = (percent) => {
    if (percent <= 50) return "bg-success"; // Green
    if (percent <= 80) return "bg-warning"; // Yellow
    return "bg-danger"; // Red
  };

  const toggleCard = (id) => {
    setExpandedCardId((prev) => (prev === id ? null : id));
  };

  return (
    <>
      <span className="budget-summery">Budget Summary</span>

      {budgets.length > 0 ? (
        budgets.map((budget) => (
          <div key={budget.bid} className="budget-summary-container">
            <div className="card custom-card-budget-summery">
              <div className="card-body">
                <h6 className="card-title d-flex justify-content-between align-items-center">
                  <span>
                    BD{String(budget.bid).padStart(3, "0")} -{" "}
                    {budget.budget_name}
                  </span>
                  <span>{formatCurrency(budget.budget)}</span>
                </h6>

                <div className="budget-summary-row fs-12">
                  <span>Spent - {budget.burn_p}%</span>
                  <span>{formatCurrency(budget.burn_a)}</span>
                </div>

                <div className="progress budget-progress">
                  <div
                    className={`progress-bar ${getProgressColorClass(
                      budget.burn_p
                    )}`}
                    style={{ width: `${budget.burn_p}%` }}
                  />
                </div>

                <div className="budget-summary-row fs-12">
                  <span>
                    Remaining - {(100 - (budget?.burn_p || 0)).toFixed(2)}%
                  </span>
                  <span>{formatCurrency(budget.remaining)}</span>
                </div>

                {expandedCardId === budget.bid && (
                  <>
                    <h6 className="task-summary-title">Task Summary</h6>

                    <table className="table custom-table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th className="w-25">Task</th>
                          <th className="w-50">Allocations</th>
                          <th className="w-25">Spent</th>
                        </tr>
                      </thead>
                      <tbody>
                        {budget.tasks?.length > 0 ? (
                          budget.tasks.map((task) => (
                            <tr key={task.task_id}>
                              <td>
                                T{String(task.task_id).padStart(3, "0")}
                              </td>
                              <td>{task.task_name}</td>
                              <td>
                                {task.assignments?.length > 0 ? (
                                  task.assignments.map((assignment, idx) => {
                                    const initials = (
                                      (assignment.first_name?.[0] || "") +
                                      (assignment.last_name?.[0] || "")
                                    ).toUpperCase();

                                    const name = `${assignment.first_name} ${assignment.last_name}`;

                                    return (
                                      <span
                                        key={idx}
                                        className="char-square custom-tooltip"
                                        data-tooltip={name}
                                      >
                                        {initials}
                                      </span>
                                    );
                                  })
                                ) : (
                                  <span className="no-data-message">
                                    No Allocations
                                  </span>
                                )}
                              </td>
                              <td>{formatCurrency(task.cost_spent)}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center">
                              No Tasks Available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </>
                )}

                <div
                  className="budget-summary-row fs-12 toggle-summary-btn"
                  onClick={() => toggleCard(budget.bid)}
                >
                  {expandedCardId === budget.bid ? (
                    <div>
                      <span className="ms-2">Collapse Task Summary</span>
                      <i className="bi bi-caret-up-fill" />
                    </div>
                  ) : (
                    <div>
                      <span className="ms-2">Expand Task Summary</span>
                      <i className="bi bi-caret-down-fill" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="col-12">
          <div className="no-content-msg">
            <span>No Budgets Available</span>
          </div>
        </div>
      )}
    </>
  );
};

export default BudgetSummary;
